import CustomBox from './Common/CustomBox';
import { HorizontalDivider } from './Common/CustomDivider';
import DetailsHeader from './Common/DetailsHeader';
import GridRowItem from './Common/GridRowItem';
import UIStrings from '@/Utils/UIStrings';

interface ProfileInformationSectionProps {
    name: string;
    location?: string;
    isWillingToRelocate: boolean | null;
    email: string;
}

function ProfileInformationSection({ name, location, isWillingToRelocate, email }: ProfileInformationSectionProps) {
    return (
        <>
            <DetailsHeader label={UIStrings.ProfileInformation} />
            <HorizontalDivider />
            <CustomBox>
                <div className="flex flex-col gap-4">
                    <GridRowItem title={UIStrings.Name} value={name} />
                    {location && <GridRowItem title={UIStrings.CurrentLocation} value={location} />}
                    {isWillingToRelocate != null && (
                        <GridRowItem
                            title={UIStrings.WillingToRelocate}
                            value={isWillingToRelocate ? UIStrings.Yes : UIStrings.No}
                        />
                    )}
                    <GridRowItem title={UIStrings.Email} value={email} />
                </div>
            </CustomBox>
        </>
    );
}

export default ProfileInformationSection;
